import React from "react";
import { motion } from "framer-motion";
import { Copy, Gift, X } from "lucide-react";
import { toast } from "sonner";

export const PrizeCelebration = ({ result, onClose }) => {
  const copy = () => {
    navigator.clipboard?.writeText(result.code).then(() => toast.success("Code copied!")).catch(() => {});
  };
  return (
    <motion.div
      initial={{ opacity: 0 }} animate={{ opacity: 1 }}
      className="fixed inset-0 z-[95] bg-black/70 flex items-center justify-center p-4"
      data-testid="spin-celebration"
    >
      <motion.div
        initial={{ scale: 0.6, rotate: -6 }} animate={{ scale: 1, rotate: 0 }} transition={{ type: "spring", stiffness: 180, damping: 14 }}
        className="relative w-full max-w-md bg-candy-cream text-candy-night border-4 border-candy-gold rounded-3xl shadow-[0_0_60px_rgba(255,215,0,0.5)] p-6 sm:p-8 text-center"
      >
        <button data-testid="spin-celebration-close" onClick={onClose} aria-label="Close" className="absolute top-3 right-3 p-1.5 border-2 border-black rounded-lg bg-white">
          <X className="h-5 w-5" />
        </button>
        <div className="text-6xl" aria-hidden>🎁</div>
        <h3 className="font-spooky text-4xl sm:text-5xl text-candy-pinkdark mt-2">You Won!</h3>
        <p className="mt-3 font-heading font-bold text-lg sm:text-xl" data-testid="spin-prize-text">
          You won {result.prize}!
        </p>
        <p className="mt-5 font-mono text-xs font-bold uppercase tracking-widest text-candy-teal">Your prize code</p>
        <button
          onClick={copy}
          data-testid="spin-prize-code"
          className="mt-2 w-full flex items-center justify-center gap-3 bg-candy-teal text-white font-display text-4xl tracking-widest py-3 border-4 border-black rounded-2xl"
        >
          {result.code} <Copy className="h-5 w-5" />
        </button>
        <p className="mt-4 text-sm font-medium leading-relaxed">
          Enter this code in the promo box at checkout.
          {result.prize_type === "free_item" && " Add your prize item to your cart and it'll be free."} One use only, valid through {result.expires}. We also emailed it to you.
        </p>
        <a
          href="#shop-christmas"
          onClick={onClose}
          data-testid="spin-celebration-shop"
          className="mt-5 inline-flex items-center gap-2 bg-candy-pink text-white font-bold uppercase tracking-wider py-3 px-6 border-4 border-black rounded-xl"
        >
          <Gift className="h-5 w-5" /> Start Shopping
        </a>
      </motion.div>
    </motion.div>
  );
};
